document.addEventListener('DOMContentLoaded', () => {

    // No groundhogg activity timeline, bail...
    if (!window.Groundhogg?.ActivityTimeline?.types) {
        return;
    }

    // No wp functions...
    if (!window.wp?.i18n?.sprintf) {
        return;
    }

    const {__, sprintf} = window.wp.i18n;

    Groundhogg.ActivityTimeline.addType('ams_cpd_entry_created', {
        iconFramed: true,
        // icon: window.Groundhogg.ActivityTimeline.types.fallback.icon,
        icon: window.Groundhogg?.element?.icons?.heartbeat || '✨',
        render: ({meta}) => {
            const title = sprintf(
                __('%s entry created', 'ams-cpd-points'),
                amsCpdPhrases.cpdLabel,
            );

            return `
                <strong>${title}</strong><br>
                <small>Entry ID: ${meta.entry_id}</small>
            `;
        }
    })

})
